import { DataPoint } from "./format-combo-tier-spend-level";

export function normalizeData(
    data: Array<DataPoint>,
) {
    return data.map((item) => {
        // The new target will be the larger of the value or target, that makes sure that the value
        // is not larger than the target.
        item.target = item.target || 0;
        item.value = item.value || 0;
        const newTarget = Math.max(item.value, item.target);

        let newItem = { ...item };

        const targetPercentageOfValue = item.target > 0 ? (item.value * 100) / item.target : 0;
        if (targetPercentageOfValue > 0 && targetPercentageOfValue < 1) {
            if (item.target === 0) {
                /**
                 * PPI-3124
                 * When the target is Zero and the spend value is between 1% and 0% ,
                 * the spend must be rounded to 1 so the target ring chart is displayed
                 * full green.
                 */

                newItem = { value: 1, target: 0 };
            }
            if (item.target > 0) {
                /**
                 * PPI-3124
                 * When the target is not Zero and the spend value is between 1% and 0% ,
                 * the spend must be rounded to 1, so the target ring chart is displayed as 4% red.
                 */
                newItem = { value: 0.04, target: item.target };
            }
        } else if (
            item.value > 0 &&
            targetPercentageOfValue <= 4 &&
            item.target > 0
        ) {
            /**
             * PPI-2798 -> PPI-2857
             * When Target is NON-Zero AND other spend values (compliance/with others)
             * are NON-Zero AND spend with seller is four percent (4%) OR less:
             * Target - display minimum 4% filled (red) ring chart
             */
            newItem = { value: 0.04, target: item.target };
        } else if (
            (item.value > 0 && item.target === 0) ||
            (item.value === 0 && item.target === 0)
        ) {
            /**
             * PPI-2798 -> PPI-2857
             * When Target is Zero (0) AND spend with seller is Zero (0)
             * and other spend values (compliance/with others) are NON-Zero:
             * Target - display full (green) ring chart
             */
            newItem = { value: 1, target: 1 };
        } else if (item.value === 0 && item.target > 0) {
            /**
             * PPI-2798 -> PPI-2857
             * Regardless of Target value, when no spend data
             * is available OR all spend values (with seller/compliance/with others)
             *  are Zero (0): Target - display empty (white) ring chart
             */
            newItem = { value: 0, target: 0 };
        } else {
            newItem = { value: item.value / newTarget, target: 1 };
        }

        return newItem;
    });
}